module.exports = __webpack_public_path__ + "static/img/11.ffe788f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/11.png
// module id = B5KD
// module chunks = 4